import { Components, Theme } from '@mui/material';

export const getMuiSvgIcon = (): Components<Theme>['MuiSvgIcon'] => ({
    styleOverrides: {
        fontSizeSmall: {
            fontSize: '16px',
        },
        fontSizeMedium: {
            fontSize: '24px',
        },
    },
    defaultProps: {
        fontSize: 'medium',
    },
});
